// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RewardRecordSection_wrapper__6L-3r","wrapper__header":"RewardRecordSection_wrapper__header__2tSq1"};